module.exports = __webpack_public_path__ + "static/media/receipt_bottom.ab4580fd.png";